import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { resetPasswordConfirm } from "../api/auth";

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const uid = searchParams.get("uid");
    const token = searchParams.get("token");
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        if (password !== confirmPassword) {
            setError("Las contraseñas no coinciden.");
            return;
        }

        if (password.length < 8) {
            setError("La contraseña debe tener al menos 8 caracteres.");
            return;
        }

        setLoading(true);
        try {
            await resetPasswordConfirm(uid, token, password);
            setSuccess(true);
            setTimeout(() => {
                navigate("/login");
            }, 3000);
        } catch (err) {
            const msg = err.response?.data?.error || err.response?.data?.detail || "Error al restablecer la contraseña.";
            if (Array.isArray(msg)) {
                setError(msg.join(" "));
            } else {
                setError(msg);
            }
        } finally {
            setLoading(false);
        }
    };

    if (!uid || !token) {
        return (
            <div className="container mt-5 text-center font-n">
                <h3>Enlace inválido</h3>
                <p>El enlace de recuperación no es válido o está incompleto.</p>
                <Link to="/login" className="btn btn-primary mt-3">Volver al inicio de sesión</Link>
            </div>
        );
    }

    return (
        <div className="container-fluid min-vh-100 bg-light d-flex align-items-center justify-content-center pb-5 font-n">
            <div className="card shadow border-0 rounded-4 overflow-hidden" style={{ maxWidth: 500, width: "100%" }}>
                <div className="card-header bg-white border-bottom py-4 text-center">
                    <h1 className="h4 fw-bold mb-1">Crear nueva contraseña</h1>
                </div>

                <div className="card-body p-5">
                    {error === "El enlace de recuperación no es válido o ha expirado." ? (
                        <div className="text-center py-3">
                            <i className="ri-error-warning-line text-danger" style={{ fontSize: '4rem' }}></i>
                            <h4 className="fw-bold mt-3 mb-3 text-danger">Enlace inválido o expirado</h4>
                            <p className="text-muted">
                                El enlace de recuperación no es válido o ya ha sido utilizado para cambiar tu contraseña.
                                Por razones de seguridad, los enlaces solo pueden usarse una vez.
                            </p>
                            <Link to="/recuperar-clave" className="btn btn-outline-primary w-100 py-2 mt-4">
                                Solicitar nuevo enlace
                            </Link>
                            <Link to="/login" className="btn btn-link text-decoration-none w-100 mt-2">
                                Volver al inicio de sesión
                            </Link>
                        </div>
                    ) : success ? (
                        <div className="text-center">
                            <i className="ri-checkbox-circle-line text-success" style={{ fontSize: '3rem' }}></i>
                            <h5 className="fw-bold mt-3 mb-4">¡Contraseña actualizada!</h5>
                            <p className="text-muted small">
                                Serás redirigido al inicio de sesión en breve...
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            <p className="small mb-4 text-muted">
                                Ingresa tu nueva contraseña para acceder a Somnus.
                            </p>

                            <div className="mb-3">
                                <label className="form-label text-secondary mb-1">Nueva Contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={password}
                                    placeholder="Ingresa tu contraseña"
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>

                            <div className="mb-4">
                                <label className="form-label text-secondary mb-1">Confirmar Contraseña</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={confirmPassword}
                                    placeholder="Ingresa tu contraseña"
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                            </div>

                            {error && <div className="alert alert-danger small py-2">{error}</div>}

                            <button type="submit" className="adm-save-btn w-100 py-2 mt-2" disabled={loading}>
                                <span>{loading ? "Guardando..." : "Guardar contraseña"}</span>
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
